import { render } from "./Thumb.vue?vue&type=template&id=08fea42a"
import script from "./Thumb.vue?vue&type=script&lang=js"
export * from "./Thumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__